// extracted by mini-css-extract-plugin
export var box = "_4y-1";
export var checkboxRow = "_4y-8";
export var checked = "_4y-2";
export var descriptionSpacer = "_4y-a";
export var disabled = "_4y-3";
export var icon = "_4y-6";
export var input = "_4y-0";
export var labelSpacer = "_4y-9";
export var medium = "_4y-5";
export var small = "_4y-4";
export var text = "_4y-7";